<template>
    <div class="pt-3 pb-4 flex flex-col gap-y-1 items-center justify-center bg-green-600/5 border border-green-600 rounded-1.25">
        <OkDoubleIcon class="text-green-600" />

        <div class="text-xs text-green-600">
            {{ messages }}
        </div>
    </div>
</template>

<script setup>
import OkDoubleIcon from '@/components/icons/OkDoubleIcon.vue'

defineProps({
    messages: {
        type: String,
        default: 'Your files have been uploaded!',
    },
})
</script>
